const sortByValue = (a: number, b: number): number => {
  return a - b;
};

export default sortByValue;
